import { downLoadFile, getPreviewImageUrl, usePrevious } from "@/utils/chat/index";
import { Button, Drawer, Form, Input, Radio, Tooltip, message, message as toast } from "antd";
import React, { useCallback, useEffect, useMemo, useState, useRef, useContext } from "react";
import styles from "./index.module.less";
import IconFont from "@/components/icon";
import { AI_CHAT_PREDICT, ChatMessage, ChatMessageType } from "@/types/chat";
import { connect } from "dvajs";
import GlobalContext, { GlobalContextConfig } from "@/context/GlobalContext";
import AIImageCard from "./AIImageCard";
import { buildMessage } from "../LLMFiles";

function AIImagePanel(props: any) {
  const {
    files,
    updateLLMInfo,
    selectedSession,
    currentEmployee,
    pushChatMessage,
    llmInfoReady
  } = props;
  const { appRuntimeEnv } = useContext<GlobalContextConfig>(GlobalContext);
  const {
    fileService: { imAppKey }
  } = appRuntimeEnv;

  // 提取图片中文字
  const sendImageExtract = useCallback(async () => {
    if (!llmInfoReady) return;
    const message = await buildMessage({
      files,
      sessionId: selectedSession.sessionId,
      currentEmployee,
      content: "帮我提取图片中的文字",
      predictType: AI_CHAT_PREDICT.IMG_EXTRA_TEXT
    });
    pushChatMessage({ sessionId: selectedSession.sessionId, message });
    updateLLMInfo(null);
  }, [
    llmInfoReady,
    files,
    selectedSession.sessionId,
    currentEmployee,
    pushChatMessage,
    updateLLMInfo
  ]);

  // 解释图片
  const sindImageExplain = useCallback(async () => {
    if (!llmInfoReady) return;
    const message = await buildMessage({
      files,
      sessionId: selectedSession.sessionId,
      currentEmployee,
      content: "帮我解释下图片",
      predictType: AI_CHAT_PREDICT.IMG_EXPLAIN
    });
    pushChatMessage({ sessionId: selectedSession.sessionId, message });
    updateLLMInfo(null);
  }, [
    llmInfoReady,
    files,
    selectedSession.sessionId,
    currentEmployee,
    pushChatMessage,
    updateLLMInfo
  ]);

  const imgFiles = useMemo(() => {
    return files.map((f: any) => {
      return {
        ...f,
        fileKey: f.fileKey || f.fileId,
        filename: f.filename || f.fileName,
        fileUrl: f.fileUrl || f.url
      };
    });
  }, [files]);

  if (!files?.length) return null;

  return (
    <div className={styles["ai-images-wrap"]}>
      <div className={styles["images-wrap"]}>
        {imgFiles.map((file: any, idx: number) => {
          console.log(`tj:>>file>>`, file);
          return (
            <AIImageCard file={file} key={`img_${file.uploadId}_${idx}`} fileList={imgFiles} />
          );
        })}
      </div>
      <div className={`${styles["control-wrap"]} ${llmInfoReady ? "" : styles["disable"]}`}>
        <div className={styles["btn"]} onClick={sendImageExtract}>
          <div className={styles["btn-inner"]}>
            <div className={styles["text"]}>提取图片中的文字</div>
          </div>
        </div>
        <div className={styles["btn"]} onClick={sindImageExplain}>
          <div className={styles["btn-inner"]}>
            <div className={styles["text"]}>解释这张图片</div>
          </div>
        </div>
      </div>
    </div>
  );
}

function mapStateToProps({ chat }: any) {
  return {
    selectedSession: chat.selectedSession,
    currentEmployee: chat.currentEmployee,
    files: chat.llmInfo?.images,
    llmInfoReady: chat.llmInfo?.isReady
  };
}

function mapDispatchToProps(dispatch: any) {
  return {
    updateLLMInfo(data: any) {
      dispatch({ type: "chat/updateLLMInfo", payload: data });
    },
    pushChatMessage(data: { sessionId: string; message: Partial<ChatMessage> }) {
      dispatch({ type: "chat/pushChatMessage", payload: data });
    }
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(AIImagePanel);
